import { Text } from "@certn/cascadia";
import { Divider } from "@certn/cascadia-react";
import { ControlProps, UISchemaElement } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsControlProps } from "@jsonforms/react";

import { handleMissingAndBlankData } from "../utils";

export function ReportArrayProcessorControl(props: ControlProps) {
  if (!props.visible) {
    return null;
  }

  if (!props.data) {
    return null;
  }

  const options = props.uischema.options || {};
  const results = props.data;

  if (results.length === 0 && options.showZeroRowsPlaceholderText) {
    return <Text>{handleMissingAndBlankData("")}</Text>;
  }

  return (
    <>
      {results.map((arrayElement: any, arrayElementIndex: number) => {
        return (
          <div key={arrayElementIndex}>
            {options?.detail.elements.map(
              (element: UISchemaElement, index: number) => {
                return (
                  <JsonFormsDispatch
                    key={index}
                    schema={props.schema}
                    uischema={element}
                    path={`${props.path}.${arrayElementIndex}`}
                  />
                );
              }
            )}
            {options.dividerBetween &&
              arrayElementIndex < results.length - 1 && <Divider />}
          </div>
        );
      })}
    </>
  );
}

export const ReportArrayProcessorControlRenderer = withJsonFormsControlProps(
  ReportArrayProcessorControl
);
